import React, { useEffect } from "react";
import Header from "../../components/Header";
import FooterTwo from "../../components/Footer/FooterTwo";
import Breadcrumb from "../../components/Breadcrumb";
import PopupForm from './PopupForm';
import CareerService from "../../services/career.service";

const ourValues = [
  {
    icon: "./img/award/doing.svg",
    title: "Doing The Right Thing",
    desc: "At OCFIT, we prioritize integrity and transparency, ensuring ethical practices and making the right choices for our students and communities.",
  },
  {
    icon: "./img/award/support.svg",
    title: "Supporting Each Other",
    desc: "At OCFIT, we believe in mutual support and collaboration, fostering a community where everyone’s growth and success are interlinked.",
  },
  {
    icon: "./img/award/bold.svg",
    title: "Being Bold",
    desc: "At OCFIT, we embrace boldness by innovating fearlessly and taking courageous steps to drive meaningful change and inspire growth.",
  },
];

const jobOpenings = [
  {
    name: "Mechatronics Trainer",
    category: "Robitics",
    location: "Delhi NCR",
    type: "Full Time/Part-Time",
  },
  {
    name: "Mechatronics Trainer1",
    category: "Robitics",
    location: "Delhi NCR",
    type: "Full Time/Part-Time",
  },
  {
    name: "Mechatronics Trainer2",
    category: "Robitics",
    location: "Delhi NCR",
    type: "Full Time/Part-Time",
  },
  {
    name: "Mechatronics Trainer",
    category: "Robitics",
    location: "Delhi NCR",
    type: "Full Time/Part-Time",
  },
  {
    name: "Mechatronics Trainer",
    category: "Robitics",
    location: "Delhi NCR",
    type: "Full Time/Part-Time",
  },
  {
    name: "Mechatronics Trainer",
    category: "Robitics",
    location: "Delhi NCR",
    type: "Full Time/Part-Time",
  },
  {
    name: "Mechatronics Trainer",
    category: "Robitics",
    location: "Delhi NCR",
    type: "Full Time/Part-Time",
  },
  {
    name: "Mechatronics Trainer",
    category: "Robitics",
    location: "Delhi NCR",
    type: "Full Time/Part-Time",
  },
  {
    name: "Mechatronics Trainer",
    category: "Robitics",
    location: "Delhi NCR",
    type: "Full Time/Part-Time",
  },
];

const Career = () => {
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [jobData,setJobData]=React.useState({});
  const [jobOpening,setJobOpenings]=React.useState([]);

  function openModal(data) {
    setIsOpen(true);
    setJobData(data);
  }


  function closeModal() {
    setIsOpen(false);
  }


  React.useEffect(()=>{
    CareerService.list()
    .then(res=>setJobOpenings(res?.data))
    .catch(err=>console.log(err));

  },[]);

  return (
    <>
        <Header
                topbarEnable='enable'
            />
      <Breadcrumb pageTitle="Career" />
      <main>
        <article className="container py-5">
          <header>
            <h2 className="fw-bold text-center text-black display-4 mt-3">
              Let's Grow{" "}
              <strong style={{color:"#FE7743"}} className="fw-semibold">Together</strong>
            </h2>
          </header>
          <p className="col-11 fs-5 text-center m-auto">
          Join us in our mission to transform lives and build a brighter future. At OCFIT, we believe in the power of collaboration and shared growth. By partnering with us, you become a vital part of our journey to empower rural youth through cutting-edge training and skill development. Together, we can bridge gaps, create opportunities, and drive sustainable change in communities. Whether you're an industry leader, a potential student, or a supporter of our cause, your involvement helps us achieve our vision of inclusive growth and empowerment. Let’s grow together and make a lasting impact on countless lives.
          </p>

          <section>
            <h3 className="text-center mt-5 display-6 fw-bold text-black">
            Our Commitment to Helping the Underprivileged
            </h3>
            <p className="text-center col-11 m-auto fs-5">At Ocfit, we believe it is our duty to help the underprivileged in society. Our founder, Ms. Vandana Sabharwal, embodies this mission, driven by the conviction that we have been blessed with abundance and must share that gift with others.</p>

            <h3 className="text-center mt-5 display-6 fw-bold text-black">
             Community Engagement
            </h3>
            <p className="text-center col-11 m-auto fs-5">Ms. Sabharwal is actively involved with various institutions dedicated to uplifting marginalized communities, including:</p>
            

            <div class="container mt-4">
              <div class="row">
                <div class="col-md-4">
                  <div class="card">
                    <div class="card-body">
                      <h5 class="card-title fw-semibold">Capt Chandanlal Blind School in Gurgaon</h5>
                      <p class="card-text">Supporting children with visual impairments by providing resources and training.</p>
                    </div>
                  </div>
                </div>

                <div class="col-md-4">
                  <div class="card">
                    <div class="card-body">
                      <h5 class="card-title fw-semibold">Earth Saviours Old Age Home in Gurgaon</h5>
                      <p class="card-text">Enhancing the lives of senior citizens through care and companionship.</p>
                    </div>
                  </div>
                </div>

                <div class="col-md-4">
                  <div class="card">
                    <div class="card-body">
                      <h5 class="card-title fw-semibold">Sarthak Trust for People with Disabilities</h5>
                      <p class="card-text">Promoting inclusion through accessible, disability-tailored vocational training.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <h3 className="text-center mt-5 display-6 fw-bold text-black">
            A Holistic Approach
            </h3>
            <p className="text-center col-11 m-auto fs-5">Through these partnerships, Ocfit creates a holistic support system that addresses the diverse needs of the communities we serve. By focusing on education, vocational training, and community engagement, we aim to foster self-sufficiency and improve the quality of life for individuals from all walks of life.</p>

            </section>

          <section>
            <h3 className="text-center mt-5 display-5 fw-bold text-black">
              Our Values
            </h3>
            <p className="text-center col-11 m-auto fs-5">
            At OCFIT, our core values guide everything we do. We are committed to Integrity, ensuring transparency and ethical practices in all our interactions. Our dedication to Excellence drives us to provide top-notch training and support to our students. We believe in Inclusivity, welcoming individuals from diverse backgrounds and empowering them equally. Innovation is at the heart of our approach, as we continuously adapt our programs to meet industry demands. Lastly, we value Collaboration, working closely with industry partners and communities to achieve our shared goals. These values shape our mission and impact, ensuring we make a positive difference in every aspect.
            </p>
            <div className="row row-cols-1 row-cols-sm-2 row-cols-lg-3 g-5 justify-content-between py-5">
              {ourValues?.map((el, idx) => (
                <figure key={idx} className=" text-center">
                  <img
                    src={el?.icon}
                    width={150}
                    height={150}
                    className="shadow bg-transparent rounded-circle  m-3"
                  />
                  <figcaption>
                    <strong className="fs-4 text-bold">{el?.title}</strong>
                    <p style={{ textAlign: "justify" }} className="fs-5 pe-4">
                      {el?.desc}
                    </p>
                  </figcaption>
                </figure>
              ))}
            </div>
          </section>
          <section>
          <h3 className="text-center mt-5 display-6 fw-bold text-black">
          Conclusion
            </h3>
            <p className="text-center col-11 m-auto fs-5">Guided by the principle of service to others, we believe in the transformative power of education and empowerment. Together, we can create a society where everyone has the opportunity to thrive.</p>
          </section>
          <section>
            <h3 className="fw-bold text-black text-center display-5 mt-3">Job Openings</h3>
            <p className="col-11 text-center m-auto">
            Explore exciting career opportunities with OCFIT! We are looking for passionate individuals to join our team and contribute to empowering rural youth through skill development and training. Check out our current job openings and be a part of a dynamic organization committed to making a positive impact in communities.
            </p>

            <div className="row row-cols-sm-2 row-cols-lg-3 g-5 py-5">
              {jobOpening?.map((el, idx) => (
                <div className="col">

                <div key={idx} className="card p-3 pb-4 shadow border-0 rounded-0">
                  <h4 className="text-black fw-bold m-0">{el?.title}</h4>
                  <div className="mt-3 mb-4">
                  <div>
                    <img
                      src="../img/career/name.svg"
                      width={18}
                      height={18}
                      className="me-3"
                    />
                    <strong className="fw-normal fs-5">Salary: {el?.salary}</strong>
                  </div>
                  <div>
                    <img
                      src="./img/career/location.svg"
                      width={18}
                      height={18}
                      className="me-3"
                    />
                    <strong className="fw-normal fs-5">Location: {el?.location}</strong>
                  </div>
                  <div className="mb-2">
                    <img
                      src="./img/career/clock.svg"
                      width={18}
                      height={18}
                      className="me-3"
                    />
                    <strong className="fw-normal fs-5">Experience: {el?.experience}</strong>
                  </div>
                  <strong className="pt-4">Description:</strong>
                  <p>{el?.detail}</p>
                  <div>
                    <h5 className="mb-2 text-decoration-underline">Hr Contact Details</h5>
                    <ul>
                      <li>Email: <a href={`mailto:${el?.hrEmail}`} className="link-danger">{el?.hrEmail}</a></li>
                      {/* <li>Contact No: <a href={`tel:${el?.hrNumber}`} className="link-danger">{el?.hrNumber}</a></li> */}
                    </ul>
                  </div>

                  </div>

                  <button
                    style={{ backgroundColor: "#FE7743" }}
                    className="btn btn-primary border-0 text-upppercase mb-2"
                    onClick={()=>openModal(el)}
                  >
                    {" "}
                    Apply Now
                  </button>
                </div>

                </div>

              ))}
            </div>
          </section>
        </article>
      </main>
      <FooterTwo />
      <PopupForm openModal={openModal} jobData={jobData} closeModal={closeModal} modalIsOpen={modalIsOpen}/>
    </>
  );
};

export default Career;
